import script from "./AudioControlsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioControlsGroup.vue?vue&type=script&setup=true&lang=js"

import "./AudioControlsGroup.vue?vue&type=style&index=0&id=bbfcbca8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbfcbca8"]])

export default __exports__